/**
 * @generated SignedSource<<e297e503a4d5f4dd9ecc5553a23139a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AccountEditDisconnectEmployeeMutation$variables = {
  id: string;
  storeId?: string | null;
};
export type AccountEditDisconnectEmployeeMutation$data = {
  readonly store: {
    readonly storeUser: {
      readonly unlinkEmployee: {
        readonly employee: {
          readonly id: string;
        } | null;
        readonly id: string;
      };
    } | null;
  };
};
export type AccountEditDisconnectEmployeeMutation = {
  response: AccountEditDisconnectEmployeeMutation$data;
  variables: AccountEditDisconnectEmployeeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "StoreUserMutation",
        "kind": "LinkedField",
        "name": "storeUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "unlinkEmployee",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employee",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountEditDisconnectEmployeeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountEditDisconnectEmployeeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "be5b5a1f1e4c8e14093bab708dd182b6",
    "id": null,
    "metadata": {},
    "name": "AccountEditDisconnectEmployeeMutation",
    "operationKind": "mutation",
    "text": "mutation AccountEditDisconnectEmployeeMutation(\n  $id: ID!\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    storeUser(id: $id) {\n      unlinkEmployee {\n        id\n        employee {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5af0c60abc85f205813fee6b72881b8f";

export default node;
